<template>
    <div :class="$style.container" id="loading" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container>
            <div id="collectionHome">
                <el-row>
                    <el-col :span="14">
                        <div style="font-size: 18px;padding: 20px;padding-top: 28px;font-weight: bold;">
                            新增客户
                        </div>
                    </el-col>
                    <el-col :span="10" v-if="is_staff_false"
                        style="height: 80px; display: flex;justify-content: flex-end;">
                        <div style="padding: 20px;padding-top: 28px;" class="people">
                            <el-form ref="form" :model="form" label-width="80px">
                                <el-form-item label="管理辖区">
                                    <el-select v-model="form.TerritoryList" placeholder="请选择" @change="xuanze">
                                        <el-option v-for="item in TerritoryList" :key="item.territory_id"
                                            :label="item.territory_name" :value="item.territory_id"
                                            :disabled="!is_staff_false">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="padding-left: 20px;">
                        <el-form>
                            <el-row>
                                <el-col :span="12" style="text-align: left;margin-top:20px;">
                                    <span style="font-weight: bold;display: inline-block;width: 70px">辖区编码</span>
                                    <el-input type="text" v-model="searchForm.territory_code" placeholder="请输入辖区编码"
                                        style="width: calc(100% - 90px)">
                                    </el-input>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="text-align: left;margin-top:20px;">
                                    <span style="font-weight: bold;display: inline-block;width: 70px">医院编码</span>
                                    <el-input type="text" v-model="searchForm.institution_code" placeholder="请输入医院编码"
                                        style="width: calc(100% - 90px)">
                                    </el-input>
                                </el-col>
                                <el-col :span="12" style="text-align: left;margin-top:20px;">
                                    <span style="font-weight: bold;display: inline-block;width: 70px">医院名称</span>
                                    <el-input type="text" v-model="searchForm.institution_name" placeholder="请输入医院名称"
                                        style="width: calc(100% - 90px)">
                                    </el-input>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="text-align: left;margin-top:20px;">
                                    <span style="font-weight: bold;display: inline-block;width: 70px">产品编码</span>
                                    <el-input type="text" v-model="searchForm.sku_code" placeholder="请输入产品编码"
                                        style="width: calc(100% - 90px)">
                                    </el-input>
                                </el-col>
                                <el-col :span="12" style="text-align: left;margin-top:20px;">
                                    <span style="font-weight: bold;display: inline-block;width: 70px">产品名称</span>
                                    <el-input type="text" v-model="searchForm.sku_name" placeholder="请输入产品名称"
                                        style="width: calc(100% - 90px)">
                                    </el-input>
                                </el-col>
                            </el-row>
                        </el-form>
                        <el-row
                            style="margin-top:80px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                            <el-col :span="12" >
                                <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                                <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
                            </el-col>
                            <el-col :span="12" >
                                <!-- <div style="float: right;margin-right: 20px;">
                                    <el-button type="primary" size="small" icon="el-icon-download">导出</el-button>
                                </div> -->
                            </el-col>
                        </el-row>

                    </el-col>
                </el-row>
                <div style="width: 100%;">

                    <div style="padding-bottom: 50px">
                        <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="customList" border
                            style="width: 100%;margin-top: 20px" stripe>
                            <el-table-column fixed type="selection" width="55">
                            </el-table-column>
                            <el-table-column min-width="80" prop="territory_code" label="辖区编码">
                            </el-table-column>
                            <el-table-column min-width="80" prop="comp_name" label="商业公司名称">
                            </el-table-column>
                            <el-table-column min-width="80" prop="institution_code" label="医院编码">
                            </el-table-column>
                            <el-table-column min-widthwidth="100" prop="institution_name" label="医院名称">
                            </el-table-column>
                            <el-table-column min-widthwidth="80" prop="sku_code" label="产品编码">
                            </el-table-column>
                            <el-table-column min-widthwidth="250" prop="sku_name" label="产品名称">
                            </el-table-column>
                            <el-table-column min-widthwidth="80" prop="user_name" label="用户名">
                            </el-table-column>
                            <el-table-column min-widthwidth="80" prop="phone" label="用户电话">
                            </el-table-column>
                            <el-table-column label-class-name="collectionHome_table_cell" fixed="right" label="操作"
                                width="80" style="color: #3b99f7">
                                <template slot-scope="scope">
                                    <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                        size="small" @click="handleDetail(scope.row)">详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagination :page="page" @changePage="changePageClick"></pagination>
                    </div>
                </div>

                <el-dialog :visible.sync="updateCustomDialog" width="700px" :show-close="false"
                    style="vertical-align: center;">
                    <div style="">
                        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                            <el-col :span="12">
                                <div style="color: #3998F7;font-size: 26px">更新客户信息
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div align="right">
                                    <el-button type="primary" size="small" @click.stop="add">
                                        保存
                                    </el-button>
                                    <el-button type="danger" size="small" @click.stop="close">
                                        关闭
                                    </el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <div style="margin-top: 20px;">
                            <el-form :model="updateCustomForm" ref="ruleForm" label-width="200px" class="demo-ruleForm"
                                hide-required-asterisk>
                                <el-form-item label="机构编码" prop="updateCustomForm.institution_code"
                                    class="collectionHome_star">
                                    <el-input v-model="updateCustomForm.institution_code" placeholder="请输入内容机构编码"
                                        style="width: 70%"></el-input>
                                </el-form-item>
                                <el-form-item label="机构名称" prop="updateCustomForm.institution_name"
                                    class="collectionHome_star">
                                    <el-input v-model="updateCustomForm.institution_name" placeholder="请输入内容机构名称"
                                        style="width: 70%"></el-input>
                                </el-form-item>
                                <el-form-item label="人员姓名" prop="updateCustomForm.user_name"
                                    class="collectionHome_star">
                                    <el-input v-model="updateCustomForm.user_name" placeholder="请输入人员姓名"
                                        style="width: 70%"></el-input>
                                </el-form-item>
                                <el-form-item label="手机号码" prop="updateCustomForm.phone" class="collectionHome_star">
                                    <el-input v-model="updateCustomForm.phone" placeholder="请输入手机号码"
                                        style="width: 70%"></el-input>
                                </el-form-item>

                            </el-form>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </el-container>
    </div>
</template>

<script>
    import http from '../../APIService/http'
    import pagination from '../../components/pagination'

    import { Message } from "element-ui";
    import moment from 'moment'


    export default {
        name: "biCustomCollect",
        data() {
            return {
                loading: false,
                form: {
                    TerritoryList: '',
                },
                TerritoryList: [],
                taskTerritoryList: [],
                searchForm: {
                    territory_code: "",
                    institution_code: "",
                    institution_name: "",
                    sku_code: "",
                    sku_name: ""
                },
                is_staff_false: true,
                updateCustomDialog: false,
                updateCustomForm: {
                },
                customList: [],
                allCustomList:[],
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                clientObj: {},
            }
        },
        components: {
            pagination,
        },
        methods: {

            async getTerritoryList() {

                let data = {
                    user_id: this.$store.getters.getUser.user_id,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }
                let self = this
                await http.post('/wapi/Territory/getTerritoryList', data).then(res => {

                    if (res.success) {
                        self.TerritoryList = res.data

                        for (var i = 0; i < self.TerritoryList.length; i++) {
                            let a = self.TerritoryList[i]
                            if (i == 0 && this.form.TerritoryList == '') {
                                this.form.TerritoryList = a.territory_id
                            }
                        }
                    } else {
                        Message.error(res.message);
                    }
                })
            },

            async getCollectBiCustom() {
                this.loading = true;
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        territory_id: this.form.TerritoryList,
                        territory_code: this.searchForm.territory_code,
                        institution_code: this.searchForm.institution_code,
                        institution_name: this.searchForm.institution_name,
                        sku_code: this.searchForm.sku_code,
                        sku_name: this.searchForm.sku_name,
                        limit: this.page.size,
                        offset: this.page.current - 1
                    }
                    await http.post('/crm/web/zmodel/getLuoshiBiCustomList', data).then(res => {
                        console.log(res);
                        if (res.success) {
                            this.customList = res.data.array
                            this.page.total = parseInt(res.data.arrayCount)
                            this.loading = false;

                        } else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {
                    this.loading = false;
                }

            },
            xuanze(value, option) {
                this.form.TerritoryList = value
                this.getCollectBiCustom();
            },
            handleQueryClick() {
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.getCollectBiCustom()
            },
            handleResetClick() {
                this.searchForm = {
                    territory_code: "",
                    institution_code: "",
                    institution_name: "",
                    sku_code: "",
                    sku_name: ""
                }
                this.getCollectBiCustom()
            },
            handleDetail(row) {
                this.updateCustomForm = row
                this.updateCustomDialog = true;
            },
            add() {
                // this.$refs["ruleForm"].validate(valid => {
                //     if (!valid) {
                //         return false
                //     } else {
                this.updateCustom()
                //     }
                // })
            },
            updateCustom() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    user_id: user.user_id,
                    key_id: this.updateCustomForm.key_id,
                    user_name: this.updateCustomForm.user_name,
                    phone: this.updateCustomForm.phone
                }
                http.post('/crm/web/zmodel/saveLuoshiBiCustom', data).then(res => {
                    if (res.success == true) {
                        this.updateCustomDialog = false
                        Message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.getCollectBiCustom()
                    }
                })
            },
            close() {
                this.updateCustomDialog = false
            },
            // 改变页码信息
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.getCollectBiCustom()
            },


            // async downloadData() {
            //     const loading = this.$loading({
            //         lock: true,
            //         text: "拼命加载中",
            //         spinner: "el-icon-loading",
            //         background: "rgba(0, 0, 0, 0.7)",
            //     });
            //     try {
            //         let user = this.$store.getters.getUser;
            //         let data = {
            //             tenant_id: user.tenant_id,
            //         };
            //         await http.post("/crm/speaker/exportSpeaker", data).then((res) => {
            //             if (res.success) {
            //                 this.allCustomList = res.data;
            //                 this.handleExportData();
            //                 loading.close();
            //                 this.$message.success('下载成功')
            //             } else {
            //                 loading.close();
            //                 this.$message.error('下载失败')
            //             }
            //         });
            //     } catch (e) {
            //         debugger;
            //         loading.close();
            //         this.$message.error('下载失败')
            //     }
            // },
            // handleExportData() {
            //     try {
            //         debugger;
            //         import("@/vendor/Export2Excel").then((excel) => {
            //             const tHeader = ["讲者编号", "讲者姓名", "工作单位", "科室/部门", "讲者职称", "担任职务", "手机号码","备用手机1","备用手机2","备用手机3","备用手机4", "邮箱", "性别", "讲者级别", "非营销项目", "签约项目", "说明", "是否启用"];
            //             const filterVal = ["speaker_code", "speaker_name", "institution", "department", "pro_title", "job_title", "mobile","mobile2","mobile3","mobile4","mobile5", "email", "gender", "speaker_level", "non_project", "project", "comments", "status"];
            //             const list = this.allCustomList;
            //             const data = this.formatJson(filterVal, list);
            //             excel.export_json_to_excel({
            //                 header: tHeader,
            //                 data,
            //                 filename: "讲者库",
            //                 autoWidth: this.autoWidth,
            //             });
            //         });
            //     } catch (err) {
            //         debugger;
            //         this.error();
            //     }
            // },

        },
        async created() {

            if (this.$store.getters.getUser.role == 'staff') {
                this.is_staff_false = false
            }
            await this.getTerritoryList();
            this.getCollectBiCustom()
            this.clientObj = this.$store.getters.getClient
            console.log(this.clientObj)

        },
        mounted() {

        },
        updated() {
        },
        beforeDestroy() {

        },
        computed: {

        },
        watch: {

        }
    }
</script>
<style lang="scss" module>
    .container {
        background: white;
        height: 100%;
        overflow: auto;

        .left {
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            float: left;
            position: absolute;
            z-index: 1;

            .type {
                em {
                    color: #d98f2f;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .first {
                color: #555555;
                font-size: 20px;
            }

            .font {
                margin-left: 20px;
                font-size: 14px;
                color: #555555;
            }
        }

        .right {
            margin-top: -20px;
            width: 100%;

            .header {
                width: 100%;
                padding-bottom: 6px;
                border-bottom: 2px dotted #e7eaec;

            }

            .body {
                overflow: auto;

            }
        }

        .noData {}
    }
</style>
<style scoped>
    .el-container {
        height: 100%;
        padding: 20px;
        background: white;
    }

    #collectionHome {
        width: 100%;
        background: white;
        position: relative;
    }

    #collectionHome>>>.el-dialog__header {
        padding-top: 0
    }

    #collectionHome>>>.el-form-item__label {
        font-size: 14px;
        color: black;
        font-weight: bold;
    }

    #collectionHome>>>.el-tag.el-tag--info {
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }

    #collectionHome>>>.el-tag.el-tag--info .el-tag__close {
        display: none;
    }

    #collectionHome>>>.collectionHome_table_cell {
        color: #2b92fa !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/customCollect/luoshi_custom.vue